export const config = {
  API_BASE_URL: "https://into-the-black-hole.valkhofmuseum.nl/",
};
